export const MESSAGES = {
  common: {
    required: '値を入力してください。',
    maxLength: '{0}文字以内で入力してください。',
    lengthRange: '{0}文字以上{1}文字以内で入力してください。',
    invalidCharacters: '入力値が無効です。もう一度確認してください。',
    specialCharacters: '特殊文字を入力しないでください。',
    onlyKatakana: 'カタカナのみを入力してください。',
    numberRange: '{0}から{1} の間で入力してください。',
    minLength: '{0}文字以上で入力してください。',
    dateLessThan: '{0}は{1}より前の日付を選択してください。',
  },
  email: {
    invalid: '入力値が無効です。もう一度確認してください。',
  },
  password: {
    rule: 'パスワードは少なくとも1つの英大文字、1つの数字、および1つの特殊文字を含めてください。',
    confirmMismatch: '確認パスワードとパスワードが不一致（再入力が必要）',
  },
  phoneNumber: {
    invalid: '電話番号の形式が正しくありません。もう一度確認してください。',
  },
  // ERROR MESSAGES
  ERR_00003: 'アカウントまたはパスワードが正しくありません。',
  ERR_00013: 'インターネットに接続されていません。',

  // VALIDATION MESSAGES
  VALID_0003: '{0}文字以内で入力してください。',
  VALID_0004: '入力値が無効です。もう一度確認してください。',

  MSG_VALID_00001: '値を入力してください。',
  MSG_VALID_00002: '{0}文字以上{1}文字以内で入力してください。',
  MSG_VALID_00003: '{0}文字以内で入力してください。',
  MSG_VALID_00004: '入力値が無効です。もう一度確認してください。',
  MSG_VALID_00014: 'カタカナのみを入力してください。',
  MSG_VALID_00021: '正の整数を入力してください。',
  MSG_VALID_00030: '{0}は{1}より前の日付を選択してください。',
};

